/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Architectural(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4982 1.82921C10.7307 1.71304 11.0066 1.72579 11.2277 1.86241C11.4487 1.99908 11.5832 2.24022 11.5832 2.50011V5.43175L16.2492 8.54308C16.4578 8.68218 16.5832 8.91636 16.5832 9.1671V16.7501H17.5002C17.9144 16.7501 18.2502 17.0859 18.2502 17.5001C18.2501 17.9143 17.9143 18.2501 17.5002 18.2501H2.50015C2.08598 18.2501 1.75022 17.9143 1.75015 17.5001C1.75015 17.0859 2.08594 16.7501 2.50015 16.7501H3.41714V5.83312C3.41727 5.54918 3.57724 5.28922 3.83121 5.16222L10.4982 1.82921ZM4.91714 6.29601V16.7501H10.0832V3.713L4.91714 6.29601ZM11.5832 16.7501H15.0832V9.56749L11.5832 7.23449V16.7501ZM7.50015 14.2501C7.91436 14.2501 8.25015 14.5859 8.25015 15.0001V15.0089C8.24984 15.4228 7.91417 15.7589 7.50015 15.7589C7.08613 15.7589 6.75046 15.4228 6.75015 15.0089V15.0001C6.75015 14.5859 7.08594 14.2501 7.50015 14.2501ZM7.50015 11.7501C7.91436 11.7501 8.25015 12.0859 8.25015 12.5001V12.5089C8.24984 12.9228 7.91417 13.2589 7.50015 13.2589C7.08613 13.2589 6.75046 12.9228 6.75015 12.5089V12.5001C6.75015 12.0859 7.08594 11.7501 7.50015 11.7501ZM7.50015 9.25011C7.91436 9.25011 8.25015 9.5859 8.25015 10.0001V10.0089C8.24984 10.4228 7.91417 10.7589 7.50015 10.7589C7.08613 10.7589 6.75046 10.4228 6.75015 10.0089V10.0001C6.75015 9.5859 7.08594 9.25011 7.50015 9.25011ZM7.50015 6.75011C7.91436 6.75011 8.25015 7.0859 8.25015 7.50011V7.5089C8.24984 7.92285 7.91417 8.2589 7.50015 8.2589C7.08613 8.2589 6.75046 7.92285 6.75015 7.5089V7.50011C6.75015 7.0859 7.08594 6.75011 7.50015 6.75011Z"
        fill="#35424F"
      />
    </svg>
  )
}

Architectural.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Architectural
